/**
 * SSR-compatible bootstrap file
 * Avoids direct window/document access during server rendering
 */

import axios from 'axios';

// Make axios available globally in both browser and Node.js environments
const globalObject = typeof window !== 'undefined' ? window : global;
globalObject.axios = axios;

// Configure axios defaults only when needed
if (typeof window !== 'undefined') {
    // Browser-only configuration
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    // Add CSRF token from meta tag if available
    const token = document.querySelector('meta[name="csrf-token"]');
    if (token) {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token.getAttribute('content');
    }
}
